import { useSelector } from 'react-redux';

import DescriptionList from '@anwb/poncho/components/description-list';
import { List, ListItem } from '@anwb/poncho/components/list';
import Typography from '@anwb/poncho/components/typography';
import { StandardEquipment, Upgrade } from 'types';

import { leaseCarInteriorColorSelector } from '../../../../../../store/selectors';
import { StandardEquipmentModalContainer } from '../styles/standardEquipmentModal.styled';
import { getSpecsForModal } from '../utils';

type Props = {
	upgrade: Upgrade;
	standardEquipmentList: StandardEquipment[];
	comparingTo: Upgrade;
};

export const EquipmentContent = ({ upgrade, standardEquipmentList, comparingTo }: Props) => {
	const interiorColor: string = useSelector(leaseCarInteriorColorSelector);
	const title: string = upgrade.monthPrice
		? `Uitrusting extra t.o.v. ${comparingTo.description}`
		: 'Standaarduitrusting';

	return (
		<>
			<DescriptionList
				dataTest="description-list-specs"
				items={getSpecsForModal(upgrade, interiorColor)}
			/>

			<StandardEquipmentModalContainer>
				{standardEquipmentList.length > 0 && (
					<>
						<Typography variant="content-subtitle">{title}</Typography>

						<List variant="bulleted" data-test="default-options-list">
							{standardEquipmentList.map((option) => (
								<ListItem data-test="default-options-list-item" key={option.name}>
									{option.descriptions}
								</ListItem>
							))}
						</List>
					</>
				)}

				{!standardEquipmentList.length && (
					<Typography variant="content-subtitle">
						Uitrusting gelijk aan {comparingTo.description}
					</Typography>
				)}
			</StandardEquipmentModalContainer>
		</>
	);
};
